require('moment/locale/en-gb') // English
require('moment/locale/nb') // Norweigan
require('moment/locale/sv') // Swedish

/** @type {import('next-translate').I18nConfig} */
const i18nConfig = {
  locales: ['sv', 'en', 'nb'],
  defaultLocale: 'sv',
  loadLocaleFrom(lang, ns) {
    return import(`./src/features/locale/locales/${lang}/${ns}.json`).then(
      m => m.default,
    )
  },
  pages: {
    '*': ['common', 'generated'],
    '/': ['home'],
    '/outlets': ['outlets', 'preOrder'],
    '/company': ['outlets', 'preOrder'],
    '/company/details': [],
    '/outlet/[outletSlug]': ['outlet', 'preOrder', 'wallets', 'giftCards'],
    '/checkout': ['checkout', 'preOrder'],
    '/checkout/result': ['result', 'checkout'],
    '/checkout/surfboard/payment': ['surfboard'],
    '/checkout/surfboard/result': ['result', 'checkout'],
    '/order-status/[outletId]/[checkoutId]': ['orderStatus', 'checkout'],
    '/account': ['account'],
    '/account/delete': ['account'],
    '/orders': ['orders', 'checkout'],
    '/order-status/qr/[orderId]': ['orderStatus', 'checkout'],
    '/giftcard/[giftCardShareKey]': ['giftCards'],
    '/giftcard/purchase/[outletSlug]': ['giftCards'],
    '/giftcard/purchase/[outletSlug]/checkout/[checkoutId]/payment': [
      'giftCards',
      'checkout',
    ],
    '/giftcard/purchase/[outletSlug]/checkout/[checkoutId]/status': [
      'giftCards',
    ],
    '/giftcard/purchase/[outletSlug]/checkout/result': ['result'],
    '/pre-order/[preOrderId]': ['preOrder'],
    '/pre-order/manage': ['preOrder'],
    '/pre-order/status/[outletId]/[preOrderId]': [
      'orderStatus',
      'checkout',
      'preOrder',
    ],
    '/pay-and-go/[outletId]/group/[groupId]': ['payAndGo'],
    '/pay-and-go/[outletId]/check/[checkId]/payment': ['payAndGo', 'surfboard'],
    '/pay-and-go/[outletId]/check/[checkId]/status': ['payAndGo'],
    '/check/result': ['result'],
    '/wallets': ['wallets'],
    '/wallets/[walletId]': ['wallets'],
  },
}

module.exports = i18nConfig
